import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiMutation } from '../../../../common/model/api.mutation';

export interface DeleteUserNoteParams {
	readonly noteId: string;
}

@Injectable({ providedIn: 'root' })
export class DeleteUserNoteApiMutation extends ApiMutation<
	string,
	DeleteUserNoteParams
> {
	client = 'iam';
	document = gql`
		mutation DeleteUserNote($noteId: UUID!) {
			deleteUserNote(noteId: $noteId)
		}
	`;
	method = 'deleteUserNote';
}
